import {useState} from "react";
import ButtonsText from "../../../../../../../components/Button/ButtonText";
import CustomDialog from "../../../../../../../components/Dialog/DiaComp";
import {TextDrugClomipramine} from "./TextDrugClomipramine"


export default function Clomipramine() {
    
    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};

return(
<>      

    <ButtonsText onClick={handleOpen} name='Clomipramine' size='large' color='common.white' />
    
    <CustomDialog open={open} onClose={handleClose}

        title="Clomipramine - PGx Recommendation"
        content={ <TextDrugClomipramine />}

        />

</>
)}